import * as z from "zod";
import { ContractField } from "./types";

export const CompanySchema = z.object({
  Id: z.number(),
  CompanyNameAr: z.string(),
  CompanyNameEn: z.string(),
  ActivityAr: z.string(),
  ActivityEn: z.string(),
  OilNumber: z.number(),
  Visible: z.boolean(),
  Value: z.string(),
});

export const ContractTypeFormRequestSchema = z.object({
  Id: z.number({ required_error: "ContractType id must be a number" }),
  ContractNo: z.string(),
  Value: z.string(),
});
export const SubContractorSchema = z.object({
  Id: z.number().optional(),
  CompanyNo: z.number().optional(),
  CompanyNameEn: z.string().optional(),
  TradeLicenseNumber: z.string().optional(),
  Value: z.string().optional(),
});

export const ContractDetailsFormDataSchema = z.object({
  [ContractField.Companies]: CompanySchema,
  [ContractField.ContractType]: ContractTypeFormRequestSchema,
  [ContractField.SubContractor]: SubContractorSchema.optional(),
});
